import { MouseEvent } from 'react';

import Button, { ButtonType } from 'inquiry/components/Button';
import { ButtonDeviceHandoffComponent } from 'lib/interfaces/ui-components';
import { UiComponentActionsApi } from 'verify/lib/interfaces/uiComponent';

interface ButtonDeviceHandoffProps {
  component: ButtonDeviceHandoffComponent;
  actionsApi: UiComponentActionsApi;
  inquiryLoading: boolean;
}

const ButtonDeviceHandoff = ({
  component,
  actionsApi,
  inquiryLoading,
}: ButtonDeviceHandoffProps) => {
  const openDeviceHandoffOptions = (e: MouseEvent) => {
    e.preventDefault();

    actionsApi.setComponent(component);
    actionsApi.route('/inquiry/device-handoff/prompt');
  };

  return (
    <Button
      id='device_handoff__button'
      type='button'
      buttonType={component.attributes['button-type'] ?? ButtonType.Primary}
      disabled={inquiryLoading}
      onClick={openDeviceHandoffOptions}
      styles={component?.styles}
    >
      {component.attributes.text}
    </Button>
  );
};

export default ButtonDeviceHandoff;
